import { render, staticRenderFns } from "./TicketDialog.vue?vue&type=template&id=08ab8632"
import script from "./TicketDialog.vue?vue&type=script&lang=js"
export * from "./TicketDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports